import {UPDATE_MODE_TYPE} from '../actionTypes';

export const modeType = (
  state = "Auto Mode",
  action,
) => {
  switch (action.type) {
    case UPDATE_MODE_TYPE:
      localStorage.setItem('modeType', action.modeType);
      return action.modeType
    default:
      return state;
  }
};
